import { message } from 'antd';
import { isCancel } from 'axios';
import { useReducer, useCallback } from 'react';
import { instance } from 'store/utils';
import { Errors } from 'utils/errors';

/**
 * @description Handles the **account confirmation submission** logic (mutation).
 * @returns {{
 *   mutate: (payload: object) => Promise<void>,
 *   isPending: boolean,
 *   isSuccess: boolean,
 *   isError: boolean,
 *   error: unknown | null
 * }} Mutation utilities.
 */
export function useConfirmRegistrationMutation() {
  const [state, dispatch] = useReducer(reducer, initialState);

  const mutate = useCallback(async payload => {
    const controller = new AbortController();
    dispatch({ type: 'MUTATION_START' });

    try {
      const res = await instance.patch(
        `/onboarding/funding-application/account`,
        payload,
        { signal: controller.signal }
      );
      dispatch({ type: 'MUTATION_SUCCESS', payload: res.data });
    } catch (err) {
      if (isCancel(err)) {
        dispatch({ type: 'MUTATION_CANCELLED' });
        return;
      }
      const errorMessage = Errors.GenericFormError;
      message.error(errorMessage);
      dispatch({ type: 'MUTATION_ERROR', payload: err });
    }
  }, []);

  return {
    mutate,
    isPending: state.isPending,
    isSuccess: state.isSuccess,
    isError: state.isError,
    error: state.error,
  };
}

const initialState = {
  isPending: false,
  isSuccess: false,
  isError: false,
  error: null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'MUTATION_START':
      return {
        ...state,
        isPending: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case 'MUTATION_SUCCESS':
      return { isPending: false, isSuccess: true, isError: false, error: null };
    case 'MUTATION_ERROR':
      return {
        isPending: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    case 'MUTATION_CANCELLED':
      return { ...state, isPending: false };
    default:
      return state;
  }
}
